import {useSnackbar} from 'notistack';
import React from 'react';
import {BackButton} from '../../Components/Buttons/BackButton';
import {CardContainer} from '../../Components/CardContainer/CardContainer';
import {CreateAndUpdateForm} from '../../Components/FormGenerators/CreateAndUpdateForm';
import {
  createEmptyEditableEventSubject,
  IEditableEventSubject,
} from '../../Components/FormGenerators/IEditableEventSubject';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import {LMessages} from '../../Localization/Localization';
import {IPageInterface} from '../entity/IPageInterface';
import {EventSubjectUpdateFields} from './fields';

/**
 * Event subject's create card.
 * @return {JSX.Element}
 * @constructor
 */
export default function EventSubjectCreateCard({}: IPageInterface) {
  const emptyEntity: IEditableEventSubject = createEmptyEditableEventSubject();

  const {enqueueSnackbar} = useSnackbar();

  return (
    <React.Fragment>

      <PageTitle title={LMessages.EVENT_SUBJECT_C_CARD_TITLE}/>

      <RowOfButtons>
        <BackButton/>
      </RowOfButtons>

      <CardContainer>
        <CreateAndUpdateForm<IEditableEventSubject>
          action={'EVENT_SUBJECT_CREATE'}
          fields={EventSubjectUpdateFields}
          data={emptyEntity}
          snackBar={enqueueSnackbar}
        />
      </CardContainer>
    </React.Fragment>
  );
};


